import PropTypes from 'prop-types';
import { Check } from 'lucide-react';
import { IconGroup, IconUngroup } from "../ToolSelectorTop/Icons.jsx";
import { useTools } from "../../ToolProvider.jsx";
import SideMenu from './SideMenu.jsx';

const DropdownGroupObjects = ({ canGroup = false, canUngroup = false }) => {
    const { onGroupObjects, onUngroupObjects } = useTools();

    return (
        <SideMenu
            tip="Agrupar / desagrupar"
            icon={<IconGroup className="w-10 h-10" />}
            as="ul"
            menuClassName="menu p-2 w-48"
        >
                <li>
                    <button
                        onClick={onGroupObjects}
                        disabled={!canGroup}
                        className="flex items-center gap-2 text-sm py-1.5 disabled:opacity-40 disabled:cursor-not-allowed"
                    >
                        <IconGroup />
                        <span>Agrupar</span>
                        {canGroup && <Check className="w-4 h-4 ml-auto" />}
                    </button>
                </li>
                <li>
                    <button
                        onClick={onUngroupObjects}
                        disabled={!canUngroup}
                        className="flex items-center gap-2 text-sm py-1.5 disabled:opacity-40 disabled:cursor-not-allowed"
                    >
                        <IconUngroup />
                        <span>Desagrupar</span>
                        {canUngroup && <Check className="w-4 h-4 ml-auto" />}
                    </button>
                </li>
        </SideMenu>
    );
};

DropdownGroupObjects.propTypes = {
    canGroup: PropTypes.bool,
    canUngroup: PropTypes.bool,
};

export default DropdownGroupObjects;
